import { SidePanel, Text, Checkbox } from '@nike/eds';
import type { VisibilityState } from '@tanstack/react-table';

interface ColumnMeta {
    id: string | undefined;
    header: string;
}

interface ColumnsSidePanelProps {
    isOpen: boolean;
    onClose: () => void;
    columnVisibility: VisibilityState;
    setColumnVisibility: React.Dispatch<React.SetStateAction<VisibilityState>>;
    columns: ColumnMeta[]; // columns prop with id and header
}

export function ColumnsSidePanel({ isOpen, onClose, columnVisibility, setColumnVisibility, columns }: ColumnsSidePanelProps) {

    const PanelContent = ({ columnVisibility, setColumnVisibility, columns }) => (
        <div className="eds-flex eds-flex--direction-column eds-gap--16 eds-spacing-mt-60 eds-spacing-mb-60" style={{ height: '100%' }}>
            <Text>Configure Table Columns</Text>
            {columns.map((col) => (
                <div key={col.id} className="eds-flex--align-items-center">
                    <Checkbox
                        id={col.id}
                        label={col.header}
                        checked={columnVisibility[col.id]}
                        onChange={() => setColumnVisibility({
                            ...columnVisibility,
                            [col.id]: !columnVisibility[col.id]
                        })}
                    />
                </div>
            ))}
        </div>
    );

    return (
        <SidePanel
            displayCheckOverride={true}
            hideScrim={true}
            onDismiss={onClose}
            isOpen={isOpen}
            headerSlot={<Text>Table Configuration</Text>}
        >
            <PanelContent
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                columns={columns}
            />
        </SidePanel>
    );
}